<template>
  <div class="wrapper">
    <div ref="description" class="text-body-1" :class="{ 'ellipsis-3-lines': !showMore }">
      <span v-if="description">
        {{ description }}
      </span>
      <span v-else class="text-lowercase-btn"></span>

      <QResizeObserver @resize="onDescriptionResize" />
    </div>

    <div v-if="description.length > 0">
      <ShowMoreLess v-if="thereIsMoreText" v-model="showMore"/>
    </div>
  </div>
</template>

<script>
// Libraries
// Components
import ShowMoreLess from '@/reusable/ShowMoreLess'

export default {
  components: {
    ShowMoreLess
  },

  props: {
    description: {
      type: String,
      default: ''
    }
  },

  data: () => ({
    showMore: true,
    thereIsMoreText: false
  }),

  methods: {
    onDescriptionResize({ height }) {
      const heightChild = this.$refs.description.firstChild.offsetHeight
      const heightParent = this.$refs.description.offsetHeight

      this.thereIsMoreText = heightChild >= heightParent || height > 48
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  .show-more-less {
    float: right;
  }
}
</style>
